module.exports = __webpack_public_path__ + "img/shadow.27ad1a96.svg";